"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  wrapper: {
    display: "x78zum5",
    flexGrow: "x1iyjqo2",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    paddingTop: "xf6mfmo",
    paddingBottom: "x1q8uoa4",
    paddingLeft: "x1oqrxb4",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xlwr664",
    textAlign: "x2b8uid",
    $$css: true
  },
  title: {
    fontSize: "x8cw2a4",
    fontWeight: "x1s688f",
    marginTop: "xdj266r",
    marginBottom: "xhbfen4",
    color: "x10kmngs",
    $$css: true
  },
  message: {
    fontSize: "x1603h9y",
    color: "xcdm7ny",
    marginBottom: "x1nhhxel",
    $$css: true
  },
  homeLink: {
    fontSize: "x1603h9y",
    color: "x19p3n1p",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    $$css: true
  }
};